export class FieldType {
    id: number;
    name: string;
}
